import React, { useRef } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import Addprouducts from '../../../components/Buttons/Trendingproducts/AddProuducts';
import { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";
import helmate from '../../../assets/images/Trendingproducts/R.jpg'
const products = [
  {
    id: 1,
    title: "Brand New Fiber Helmet",
    image: helmate,
    description: "Electronics is the study and use of electrical components like .....",
    price: 1100,
    oldPrice: 3000,
    verified: true,
  },
  {
    id: 2,
    title: "Brand New Fiber Helmet",
    image: helmate,
    description: "Electronics is the study and use of electrical components like .....",
    price: 2000,
    oldPrice: 3000,
    verified: true,
  },
   {
    id: 3,
    title: "Brand New Fiber Helmet",
    image: helmate,
    description: "Electronics is the study and use of electrical components like .....",
    price: 3000,
    oldPrice: 3000,
    verified: true,
  },
   {
    id: 4,
    title: "Brand New Fiber Helmet",
    image: helmate,
    description: "Electronics is the study and use of electrical components like .....",
    price: 4000,
    oldPrice: 3000,
    verified: true,
  },
   {
    id: 5,
    title: "Brand New Fiber Helmet",
    image: helmate,
    description: "Electronics is the study and use of electrical components like .....",
    price: 5000,
    oldPrice: 3000,
    verified: true,
  },
   {
    id: 6,
    title: "Brand New Fiber Helmet",
    image: helmate,
    description: "Electronics is the study and use of electrical components like .....",
    price: 6000,
    oldPrice: 3000,
    verified: true,
  },
   {
    id: 7,
    title: "Brand New Fiber Helmet",
    image: helmate,
    description: "Electronics is the study and use of electrical components like .....",
    price: 6000,
    oldPrice: 3000,
    verified: true,
  },
   {
    id: 8,
    title: "Brand New Fiber Helmet",
    image: helmate,
    description: "Electronics is the study and use of electrical components like .....",
    price: 7000,
    oldPrice: 3000,
    verified: true,
  },
  // Add more as needed...
];
const Trendingproduct = () => {

  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 4; // Number of cards visible at a time

  const prevSlide = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const nextSlide = () => {
    setStartIndex((prev) =>
      Math.min(prev + 1, products.length - visibleCount)
    );
  };

  // const scrollRef = useRef(null);

  // const scrollLeft = () => {
  //   scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
  // };

  // const scrollRight = () => {
  //   scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
  // };

  return (
    <div className="mt-11 mb-8 max-w-7xl">
       <div className="flex p-2 justify-center items-center gap-2">
      <span
        data-tooltip-id="trendingTooltip"
        data-tooltip-html={`
          <div class='tooltip-bubble'>
            <div class='tooltip-content'>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
              Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
            </div>
            <div class='tooltip-tail'></div>
          </div>
        `}
        className="text-2xl mt-1 cursor-pointer"
      >
        <HiOutlineInformationCircle />
      </span>
      <h1 className="font-semibold text-2xl">Trending Products</h1>

      <Tooltip
        id="trendingTooltip"
        place="bottom"
        offset={10}
        className="!bg-transparent !p-0 !rounded-none ms-28 z-30"
      />
    </div>

     <div className="relative bg-gray-800 p-4 overflow-hidden">
  <div className="flex items-center">
    {/* Left arrow */}
    <button onClick={prevSlide} className="text-white text-2xl px-2">
     <MdKeyboardArrowLeft />
    </button>

    {/* Slider container with overflow */}
    <div className="overflow-hidden w-full">
      {/* Slider track that animates with transform */}
      <div
        className="flex gap-4 transition-transform duration-500 ease-in-out"
        style={{
          transform: `translateX(-${startIndex * 256}px)`, // 240 + 16px gap
        }}
      >
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-white rounded-lg shadow-md w-44  h-60 p-3 pt-0 flex-shrink-0 flex flex-col justify-between"
          >
            
            <div className="relative  h-28 flex justify-center items-center  ">
              <img
                src={product.image}
                alt={product.title}
                className="h-20 mt-6    object-contain z-30 "
              />
              <span className="absolute top-0 right-0 translate-x-3 bg-blue-500 text-white text-xs px-2 ms-5 ">
                Up to 30% off
              </span>
            </div>

            {/* Title */}
            <h3 className="font-semibold text-sm mt-1 leading-tight line-clamp-1 ">
              {product.title}
            </h3>

            {/* Description */}
            <p className="text-xs text-gray-500 leading-tight line-clamp-2">
              {product.description}
            </p>

            {/* Seller Info */}
            <div className="flex items-center text-xs mt-1 gap-1">
              <span>Sanjai</span>
              <span>🇮🇳</span>
              {product.verified && (
                <span className="text-blue-600 font-bold">Verified ✅</span>
              )}
            </div>

            {/* Price */}
            <div className="mt-1 text-sm">
              <span className="text-black font-bold">₹ {product.price} INR</span>
              <span className="line-through text-gray-400 text-xs ml-2">
                ₹ {product.oldPrice}
              </span>
            </div>

            {/* Buttons */}
            <div className="flex justify-between mt-1">
              <button className="bg-red-500 text-white text-xs px-3 py-1 rounded">
                Get Quotes
              </button>
              <button className="border text-xs px-3 py-1 rounded">
                Contact
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Right arrow */}
    <button onClick={nextSlide} className="text-white text-2xl px-2">
    <MdKeyboardArrowRight />
    </button>
  </div>
</div>

<div className="mt-8 mb-3 flex justify-center text-xl font-semibold text-gray-700 ">
        <h1>Edit Your Banner Below Here</h1>
      </div>


      <div>
          <Addprouducts/>
        </div>
    </div>
  );
};

export default Trendingproduct;
